/*---------------------------------------------------------------------------*
 *  DOM TOGGLER
 *---------------------------------------------------------------------------*
 *
 *  Module for toggling classes in the DOM using only HTML data attributes.
 *
 *  Available attributes are:
 *
 *  [data-toggle="{CSS selector}"]   CSS selector for target elements to toggle
 *  [data-toggle-class="{classes}"]  CSS class(es) to toggle (default: 'is-active')
 *  [data-toggle-once="true"]        Whether to toggle only once (default: false)
 *  [data-toggle-self="false"]       Whether to toggle class on trigger (default: true)
 *  [data-toggle-prevent="true"]     Whether to prevent default event (default: true)
 *
 *  Author: PubliOne S.r.l.
 *  Author URI: http://publione.it
 *
 *  @version  1.0.0
 *
 */

var DOMToggler = function () {
  'use strict';

  /**
   * Constructor.
   *
   * @constructor
   * @param {string} selector CSS selector used for the module
   */
  function DOMToggler() {
    this.isSupported = 'classList' in document.createElement( 'p' );
    this.elements = document.querySelectorAll( '[data-toggle]' );

    this.version = '1.0.0';

    this.multiToggle = this.multiToggle.bind( this );

    this.init();
  }

  DOMToggler.prototype.multiToggle = function( element, classNames ) {
    classNames = classNames || [];

    // turn string into array of class names
    if ( typeof classNames === 'string' ) {
      classNames = classNames.replace( ',', ' ' );
      classNames = classNames.split( /\s+/ );
    }

    [].forEach.call( classNames, function( className ) {
      element.classList.toggle( className );
    });
  };

  DOMToggler.prototype.toggleHandler = function( trigger, event ) {
    var multiToggle = this.multiToggle;

    var selector       = trigger.dataset.toggle || '';
    var classNames     = trigger.dataset.toggleClass || 'is-active';
    var toggleOnce     = trigger.dataset.toggleOnce == 'true';
    var toggleSelf     = trigger.dataset.toggleSelf != 'false';
    var preventDefault = trigger.dataset.togglePrevent != 'false';

    if ( selector ) {
      [].forEach.call( document.querySelectorAll( selector ), function( target ) {
        multiToggle( target, classNames );
      });
    }
    if ( toggleSelf ) {
      multiToggle( trigger, classNames );
    }
    if ( toggleOnce ) {
      this.unbind( trigger, event );
    }
    if ( preventDefault ) {
      event.preventDefault();
    }
  };

  DOMToggler.prototype.bind = function( trigger, event ) {
    trigger.addEventListener( event, this.toggleHandler.bind( this, trigger ) );
  };

  DOMToggler.prototype.unbind = function( trigger, event ) {
    trigger.removeEventListener( event, this.toggleHandler.bind( this, trigger ) );
  };

  DOMToggler.prototype.init = function() {
    var that = this;
    [].forEach.call( this.elements, function( trigger ) {
      var event = trigger.dataset.toggleEvent || 'click';
      that.bind( trigger, event );
    });
  };

  DOMToggler.prototype.destroy = function() {
    var that = this;
    [].forEach.call( this.elements, function( trigger ) {
      var event = trigger.dataset.toggleEvent || 'click';
      that.unbind( trigger, event );
    });
  };

  DOMToggler.prototype.refresh = function() {
    this.destroy();
    this.init();
  };

  return DOMToggler;
}();

/**
 * Export function that supports AMD, CommonJS and Plain Browser.
 */
( function ( root, factory ) {
  if ( typeof exports !== 'undefined' ) {
    module.exports = factory;
  } else if ( typeof define === 'function' && define.amd ) {
    define( [], factory );
  } else {
    root.DOMToggler = factory;
  }
})( this || window, DOMToggler );
